export default {"src":"https://cdn.jetlend.ru/_next/static/media/arrow-right-long.ef88c5da.svg","height":37,"width":36,"blurWidth":0,"blurHeight":0};